import React, { Component } from "react";
import { Link } from "react-router-dom";

import API from "../../../actions/api-helper";
import UI from "../../../actions/ui-helper";
import DataUtil from "../../../actions/data";
import StringUtil from "../../../actions/string";

let wrapStyle = {
  whiteSpace: "pre-wrap",
  fontSize: "12px"
}

class ConsultaAtendimentoResultado extends Component {
  constructor(props) {
    super(props);
    this.definirPagamento = this.definirPagamento.bind(this);
  }

  componentWillUpdate() {
    UI.destroyTable(this.tableId);
  }

  componentDidUpdate() {
    UI.dataTable(this.tableId);
  }

  definirPagamento(reuniao) {
    UI.loader("show", "Um momento...");
    if (DataUtil.validarData(reuniao.dataPagamento)) {
      reuniao.dataPagamento = "";
    }
    else {
      reuniao.dataPagamento = DataUtil.hoje();
    }

    API.post("/reunioes", reuniao).then(function (json) {
      UI.alert(json.success, json.message);
      UI.loader("hide");
      this.forceUpdate();
    }.bind(this)
    ).catch(function (json) {
      UI.alert(false, json.message);
      UI.loader("hide");
    })
  }

  render() {
    if (this.props.resultado.length === 0) {
      return false;
    }
    this.tableId = StringUtil.uuid(5);

    return (
      <div className="row">
        <div className="col-12 grid-margin">
          <div className="row">
            <div className="col-12 table-responsive">
              <table key={StringUtil.uuid(5)} id={this.tableId} className="table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Data</th>
                    <th>Horário</th>
                    <th>Procedimento</th>
                    <th>Profissional</th>
                    {this.props.habilitarPagamento && <th>Pagamento</th>}
                    <th>Editar</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.resultado.map((reuniao, i) => {
                    return (
                      <tr key={reuniao.id}>
                        <td>{reuniao.id}</td>
                        <td>{reuniao.data}</td>
                        <td>{reuniao.horaEntrada.substring(0, 5)} - {reuniao.horaSaida.substring(0, 5)}</td>
                        <td style={wrapStyle}>{reuniao.procedimento.codigo + " - " + reuniao.procedimento.descricao}</td>
                        <td style={wrapStyle}>
                          {reuniao.valores.map((valor) => {
                            return (<div
                              key={valor.usuarioId}
                              className="badge badge-default badge-gray badge-xs">{valor.usuarioNome}</div>)
                          })}
                        </td>
                        {this.props.habilitarPagamento && <td>
                          {reuniao.tipo === 2 && <div className="badge badge-info badge-xs">Cancelada</div>}
                          {reuniao.tipo < 2 && DataUtil.validarData(reuniao.dataPagamento) &&
                            <button
                              className="btn btn-xs btn-success"
                              type="button"
                              onClick={() => this.definirPagamento(reuniao)}
                            >
                              Recebido
                      </button>}
                          {reuniao.tipo < 2 && !DataUtil.validarData(reuniao.dataPagamento) &&
                            <button
                              className="btn btn-xs btn-danger"
                              type="button"
                              onClick={() => this.definirPagamento(reuniao)}
                            >
                              Pendente
                        </button>}
                        </td>}
                        <td>
                          <div className="dropdown">
                            <button className="btn btn-xs btn-light icon-btn btn-option" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                              <i className="fa fa-cog"></i>
                            </button>
                            <div className="dropdown-menu">
                              <Link
                                to={"/reuniao/cadastro/" + reuniao.id}
                                className="dropdown-item"><i className="fa fa-edit"></i>&nbsp;Editar</Link>
                              <Link
                                to={"/impressao/reuniao/" + reuniao.id}
                                className="dropdown-item"><i className="fa fa-print"></i>&nbsp;Imprimir</Link>
                              <Link
                                to={"/reuniao/auditoria/" + reuniao.id}
                                className="dropdown-item"><i className="fa fa-clock-o"></i>&nbsp;Auditoria</Link>
                              <span onClick={() => this.props.onDuplicar(reuniao, i)} className="dropdown-item"><i className="fa fa-code-fork"></i>&nbsp;Duplicar</span>
                              <span onClick={() => this.props.onExcluir(reuniao, i)} className="dropdown-item"><i className="fa fa-times"></i>&nbsp;Excluir</span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ConsultaAtendimentoResultado;
